var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef, } from 'react';
import { FieldLabel } from '../../Elements/FieldLabel';
import { FieldSelect, OptGroup, Option } from '../../Elements/FieldSelect';
import { FieldSubText } from '../../Elements/FieldSubText';
import { filteredStringList } from '../../../../utils/filtered-string-list';
import styles from './SelectField.module.scss';
/**
 * @tdr
 * @tdr-candidates: select
 */
var SelectField = forwardRef(function (_a, ref) {
    var advisoryText = _a.advisoryText, ariaDescribedBy = _a.ariaDescribedBy, children = _a.children, className = _a.className, disabled = _a.disabled, errorText = _a.errorText, helpText = _a.helpText, helpTextIconHidden = _a.helpTextIconHidden, id = _a.id, indicateOptional = _a.indicateOptional, indicateRequired = _a.indicateRequired, label = _a.label, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, placeholder = _a.placeholder, required = _a.required, dataTest = _a.dataTest, defaultValue = _a.defaultValue;
    var labelId = "".concat(id, "-label");
    var advisoryTextId = "".concat(id, "-advisoryText");
    var errorTextId = "".concat(id, "-errorText");
    var helpTextId = "".concat(id, "-helpText");
    var hasError = !!errorText;
    var describedBy = filteredStringList([
        !!advisoryText && advisoryTextId,
        hasError && errorTextId,
        !!helpText && helpTextId,
        ariaDescribedBy,
    ]);
    return (React.createElement("div", { className: styles.container },
        React.createElement(FieldLabel, __assign({}, {
            disabled: disabled,
            id: labelId,
            label: label,
            labelForId: id,
            indicateOptional: indicateOptional,
            indicateRequired: indicateRequired,
        })),
        React.createElement(FieldSubText, { hideIcon: helpTextIconHidden, id: helpTextId, text: helpText, type: "help" }),
        React.createElement(FieldSelect, __assign({}, {
            'aria-describedby': describedBy,
            'aria-invalid': hasError,
            'aria-labelledby': labelId,
            'aria-required': required,
            'data-test': dataTest,
            className: className,
            disabled: disabled,
            hasError: hasError,
            id: id,
            name: name,
            onBlur: onBlur,
            onChange: onChange,
            onFocus: onFocus,
            placeholder: placeholder,
            defaultValue: defaultValue,
        }, { ref: ref }),
            (placeholder || placeholder === '') && React.createElement(Option, { value: "" }, placeholder),
            children),
        React.createElement(FieldSubText, { id: errorTextId, text: errorText, type: "error" }),
        React.createElement(FieldSubText, { id: advisoryTextId, text: advisoryText, type: "advisory" })));
});
export { SelectField, OptGroup, Option };
//# sourceMappingURL=SelectField.js.map